"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRem = createRem;
exports.createSpacing = createSpacing;
exports.px = px;
exports.spacing = exports.rem = void 0;

/**
 * Functions transforms/generates values for CSS properties
 */

/** Creates px based value */
function px(value) {
  return "".concat(value, "px");
}
/** Creates rem based value */


function createRem(value, base) {
  return "".concat(value / base, "rem");
}
/** Creates spacer */


function createSpacing(multiplier, base) {
  return base * multiplier;
}
/** Calculates pixel value as rem */


const rem = value => props => createRem(value, props.theme.remBase);
/** Calculates spacing in rem units */


exports.rem = rem;

const spacing = function () {
  let multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return props => createRem(createSpacing(multiplier, props.theme.spaceBase), props.theme.remBase);
};

exports.spacing = spacing;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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